import { AnalyticsInterface } from './AnalyticsInterface';
import { EmptyAnalytics } from './EmptyAnalytics';
import { GoogleAnalytics } from './GoogleAnalytics';

export const analytics: AnalyticsInterface =
  import.meta.env.MODE === 'development' ? new EmptyAnalytics() : new GoogleAnalytics();
